<template>
  <div class="o-schedule">
    <div class="c-mobile-out">
      <div class="o-schedule__search bg-prim-light d-flex justify-content-center py-4 px-3 px-md-4">
        <div class="p-md-2 text-center">
          <h1 class="c-ttl c-ttl--mdp">Schedule</h1>

          <p class="mt-1 fw-r">
            Venezia Lines performs trips between Italy, Croatia and Slovenia as
            from APRIL until OCTOBER.
          </p>

          <div class="text-left">
            <form autocomplete="off" method="get" @submit.prevent="submitSearch">
              <div class="o-search__fields">
                <route-selector
                  :origin="search.origin"
                  :destination="search.destination"
                  @update:origin="search.origin = $event"
                  @update:destination="search.destination = $event"
                ></route-selector>

                <div class="is-single">
                  <select-2
                    :options="dateOptions"
                    v-model="search.month"
                  ></select-2>
                </div>
                <div>
                  <button class="btn btn-primary w-100" type="submit"
                    :disabled="!search.origin || !search.destination || !search.month"
                  >Search</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        class="o-schedule__content w-100 mw-1000 my-3 my-md-5 mx-auto"
        v-if="loaded || loading"
      >
        <div class="o-schedule__content-head mb-4 pb-3">
          <div class="o-schedule__content-control">
            <button type="button" class="c-control is-prev" :class="{ 'visibility-hidden': !hasPrevMonth }" @click="prevMonth">
              <span class="icon-chevron-left"></span>
            </button>
          </div>

          <div class="o-schedule__content-titles w-100 mw-350 text-center">
            <h3 class="c-ttl px-2">
              <span class="cl-sec-l d-block mb-1"
                >{{ selectedOrigin.name }} -
                {{ selectedDestination.name }}</span
              >
              <span>{{ dateOptions.find(option => option.id == selectedDate).text }}</span>
            </h3>
          </div>

          <div class="o-schedule__content-control">
            <button type="button" class="c-control is-next" :class="{ 'visibility-hidden': !hasNextMonth }" @click="nextMonth">
              <span class="icon-chevron-left"></span>
            </button>
          </div>
        </div>

        <div class="o-schedule__content-body">
          <loader v-if="loading"></loader>
          <schedule-trips v-else :trips="trips" :origin="selectedOrigin.id" :destination="selectedDestination.id"></schedule-trips>
        </div>

        <div class="o-schedule__content-head mt-4 pt-3" v-if="loaded">
          <div class="o-schedule__content-control">
            <button type="button" class="c-control is-prev" :class="{ 'visibility-hidden': !hasPrevMonth }" @click="prevMonth">
              <span class="icon-chevron-left"></span>
            </button>
          </div>

          <div class="o-schedule__content-titles w-100 mw-350 text-center">
            <h3 class="c-ttl px-2">
              <span class="cl-sec-l d-block mb-1"
                >{{ selectedOrigin.name }} -
                {{ selectedDestination.name }}</span
              >
              <span>{{ dateOptions.find(option => option.id == selectedDate).text }}</span>
            </h3>
          </div>

          <div class="o-schedule__content-control">
            <button type="button" class="c-control is-next" :class="{ 'visibility-hidden': !hasNextMonth }" @click="nextMonth">
              <span class="icon-chevron-left"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteSelector from "../components/RouteSelector.vue";
import Select2 from "../components/Select2.vue";
import Loader from "../components/Loader.vue";
import ScheduleTrips from './ScheduleTrips.vue';
import { mapState, mapGetters } from 'vuex'

export default {
  components: { RouteSelector, Select2, Loader, ScheduleTrips },
  data() {
    return {
      search: {
        origin: "",
        destination: "",
        month: "",
      },
      loaded: false,
      loading: false,
      trips: [],
      dateOptions: [],
      selectedOrigin: null,
      selectedDestination: null,
      selectedDate: "",
    };
  },
  computed: {
    hasPrevMonth() {
      let index = this.dateOptions.findIndex(option => option.id == this.selectedDate)
      return (index > 0)
    },
    hasNextMonth() {
      let index = this.dateOptions.findIndex(option => option.id == this.selectedDate)
      return (index > -1 && index < this.dateOptions.length - 1)
    },
    ...mapState([
      'ports'
    ]),
    ...mapGetters([
      'getPortById'
    ])
  },
  created() {
    let vm = this
    window.addEventListener("popstate", function(event) {
      if (event.state) {
        vm.search.origin = event.state.origin.toString()
        vm.search.destination = event.state.destination.toString()
        vm.search.month = event.state.month.toString()
        vm.submitSearch(false)
      }
    });
  },
  mounted() {
    let searchParams = new URLSearchParams(window.location.search)

    this.search.origin = searchParams.get('_o')
    this.search.destination = searchParams.get('_d')

    let month = searchParams.get('_m')

    this.setDateOptions();
    this.$nextTick(
      () => {
        (this.search.month =
          month &&
          this.dateOptions.find((option) => option.id == month)
            ? month
            : this.dateOptions[0].id)
            if (this.search.month && this.search.origin && this.search.destination) {
              this.submitSearch(false)
            }
      }
    );
  },
  methods: {
    submitSearch(pushState) {
      this.selectedOrigin = this.getPortById(this.search.origin);
      this.selectedDestination = this.getPortById(this.search.destination);
      this.selectedDate = this.dateOptions.find((option) => option.id == this.search.month).id;
      this.getTrips(pushState)
    },
    nextMonth() {
      if (this.loading) return
      let index = this.dateOptions.findIndex(option => option.id == this.selectedDate)
      if (index > -1 && index < this.dateOptions.length - 1) {
        this.search.month = this.selectedDate = this.dateOptions[index + 1].id
        this.getTrips()
      }
    },
    prevMonth() {
      if (this.loading) return
      let index = this.dateOptions.findIndex(option => option.id == this.selectedDate)
      if (index > 0) {
        this.search.month = this.selectedDate = this.dateOptions[index - 1].id
        this.getTrips()
      }
    },
    pushState() {
      let searchParams = new URLSearchParams()
      searchParams.set('_o', this.selectedOrigin.id)
      searchParams.set('_d', this.selectedDestination.id)
      searchParams.set('_m', this.selectedDate)
      history.pushState({
        origin: this.selectedOrigin.id,
        destination: this.selectedDestination.id,
        month: this.selectedDate,
      }, document.title, window.location.href.split('?')[0]+'?'+searchParams.toString())
    },
    async getTrips(pushState) {
      this.loading = true;

      if (pushState === undefined) {
        pushState = true
      }

      pushState && this.pushState()

      let date = moment(this.selectedDate, "YYYYMM");

      this.trips = await this.$api.schedule({
        origin_id: this.selectedOrigin.id,
        destination_id: this.selectedDestination.id,
        date_from: date.startOf('month').format('YYYY-MM-DD'),
        date_to: date.endOf('month').format('YYYY-MM-DD')
      })
      this.loaded = true
      this.loading = false
    },
    setDateOptions() {
      this.dateOptions = [];
      let date = moment().date(1);
      let lastDate = moment()
        .date(1)
        .month(9)
        .year(date.month() >= 8 ? date.year() + 1 : date.year());

      while (date.isBefore(lastDate)) {
        if (date.month() > 2 && date.month() < 10) {
          this.dateOptions.push({
            id: date.format("YYYYMM"),
            text: date.format("MMMM YYYY"),
          });
        }
        date.add(1, "months");
      }
    },
  },
};
</script>
